<template>
  <div
    class="rrbldfreq"
    draggable="false"
  >
    <!-- <div class="text-medium clr-grey">
      {{ $t(`range_builder.auto_setup_matrix`) }}
    </div> -->

    <!-- <div class="text-medium weight_500 clr-grey">{{ $t('common.overwrite') }}:</div> -->

    <GwBtns
      class="w-100"
      :options="[
        { id: 'overwrite_all', text: $t('range_builder.ovewrite_all_hands') },
        { id: 'keep_locked_hands', text: $t('range_builder.ovewrite_unlocked_hands') },
      ]"
      :value="nodelockFreqMode"
      idKey="id"
      style="
        margin: 0 0 0.25rem 0;
        background: var(--clr-black-1-3);
        border-radius: 4px;
        --gwbtns-padding: 2px;
        --gwbtn-padding: 0 2rem;
        --gwbtn-clr-active-white: var(--clr-black-3);

        --gwbtn-flex: 1;
      "
      @click="(_e, item) => $emit('update:nodelockfreqmode', item.id)"
    >
      <template #default="{ item }">
        <div
          v-if="item.id === 'keep_locked_hands'"
          class="mdi mdi-lock-open-variant-outline mr-1"
        />
        <div
          v-if="item.id === 'overwrite_all'"
          class="mdi mdi-restore mr-1"
        />
        {{ item.text }}
      </template>
    </GwBtns>
    <div class="rrbldfreq_actions no-scroll-track">
      <slot />

      <div
        v-for="(action, aIdx) in l_solution"
        :key="`${action.code}_${aIdx}`"
        class="rrbldfreq_actions_item"
      >
        <div
          class="f-center"
          style="margin: 0 0.5rem 0 0"
        >
          <div class="rrbldfreq_actions_item_name truncate">
            {{ action.display_name || $t(`browse.${action.group_display_name}`) }}
            <span v-html="getBetHtml({ showBetsIn, a: action, simple: false })" />
          </div>
          <div
            class="gw_btn ml-auto csst csst_nm"
            style="z-index: 8; height: 1.5rem; width: 1.5rem"
            :style="action.is_locked ? '--clr-back: rgba(245, 83, 83, 0.2)' : ''"
            @click="handleLock(action)"
            @mouseenter="e => fl_positionTooltip(e, { placement: 'right' })"
          >
            <div
              class="mdi"
              :class="[
                { 'no-events opacity_4': !canLock },
                action.is_locked ? 'mdi-cancel clr-error' : 'mdi-cancel clr-grey',
              ]"
            ></div>
            <div
              class="csst_content clr-white"
              style="position: fixed"
              v-html="
                action.is_locked ? $t('tooltips.unignore_action') : $t('tooltips.ignore_action')
              "
            />
          </div>
        </div>
        <div
          class="f-center flex-1"
          style="transition: 0.22s ease-in-out"
          :class="{ 'no-events opacity_3': action.is_locked }"
        >
          <RangeInput
            class="rrbldfreq_actions_item_slider"
            :values="[
              {
                id: 0,
                cssStyle: `
                --clr-input-back: ${action.hex};
                --clr-input-handle: ${action.hex};
                `,
                percentage: action.strategy,
              },
              {
                id: 1,
                cssStyle: `--clr-input-back: var(--clr-black-3);`,
                percentage: 1 - action.strategy,
              },
            ]"
            :balance="1"
            style="--rainput-height: 1.5rem"
            @values:updateend="
              ({ values }) => handleInput({ idx: aIdx, num: values[0].percentage })
            "
          />

          <div
            class="f-center"
            style="gap: 0.25rem; margin: 0 0 0 1rem"
          >
            <NumberInput
              class="rrbldfreq_actions_item_input numinput_white"
              :hasMinus="false"
              :hasPlus="false"
              :min="0"
              :max="100"
              :step="1"
              :decimals="0"
              :tabindex="action.is_locked ? -1 : 1"
              :value="numFixed(action.strategy * 100, 0)"
              style="
                --clr-focus: var(--clr-primary);
                font-size: 0.875rem;
                --input-clr-arrow-disabled: var(--clr-white-0);
              "
              @input="num => handleInput({ idx: aIdx, num: num / 100 })"
            />
            %
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NumberInput from '@/components/lib/NumberInput'
import RangeInput from '@/components/lib/RangeInput'
import GwBtns from '@/components/lib/GwBtns'
import { throttle } from 'lodash'
import { getGroupedActions, getUngroupedActions } from '@/helpers/grouping'
import { getEqualSolution } from '@/helpers/rangeBuilder'
import { toggleArr } from '@/helpers/helpers'

import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'RangeBuilderActionsSliders',
  mixins: [format_mix, float_mix],
  props: {
    solution: { default: () => [] },
    showBetsIn: String,
    useHex: Boolean,
    nodelockFreqMode: { default: 'keep_locked_hands' },
    grouping: { default: () => [] },
    lockedActions: { default: () => [] },
  },
  emits: ['update:nodelockfreqmode', 'update:lockedactions', 'update:actionssliders'],
  data() {
    this.presets = [0, 0.25, 0.5, 0.75, 1]
    return {
      l_solution: [],
    }
  },
  methods: {
    handleLock(action) {
      if (!this.canLock) return

      const actions = action.actions ? action.actions.map(aa => aa.code) : [action.code]
      let lockedActions = toggleArr({
        arr: this.lockedActions,
        items: actions,
        addToStart: false,
      })
      if (lockedActions.length > this.solution.length - 2) {
        const firstLockedAction = this.l_solution.filter(i => i.is_locked)[0]
        const toBeRemoved = firstLockedAction?.actions
          ? firstLockedAction.actions.map(aa => aa.code)
          : [firstLockedAction?.code]

        lockedActions = toggleArr({
          arr: lockedActions,
          items: toBeRemoved,
          addToStart: false,
        })
      }
      // console.log(lockedActions)
      this.$emit('update:lockedactions', lockedActions)
    },
    handleInput({ idx, num }) {
      if (this.l_solution[idx]?.is_locked) return

      num = this.numFixed(num, 2)
      if (this.numFixed(this.l_solution[idx]?.strategy, 2) === num) return

      let res = this.l_solution.map((i, aIdx) =>
        idx === aIdx
          ? {
              ...i,
              strategy: num,
              active: true,
            }
          : {
              ...i,
              active: false,
            },
      )
      if (!this.useHex) {
        res = res.map((i, aIdx) => {
          if (aIdx === idx && i.actions) {
            i.actions = getEqualSolution({
              solution: i.actions,
              total: i.strategy,
            })
          }
          if (i.actions) {
            i.actions = i.actions.map(aa => {
              aa.active = aIdx === idx
              return aa
            })
          }
          return i
        })
        res = getUngroupedActions({ actions: res })
      }

      this.setSolution(res)
      this.emitValues(res)
    },
    emitValues: throttle(function (res) {
      this.$emit('update:actionssliders', {
        actions: res,
        keepLocks: this.nodelockFreqMode === 'keep_locked_hands',
      })
    }, 333),
    setSolution(solution) {
      let res = getGroupedActions({
        actions: solution,
        grouping: this.grouping,
        groupValues: ['strategy'],
        raisesFirst: true,
      })
      res = res.map(aa => {
        if (aa.actions) {
          aa.actions = aa.actions.map(aaa => {
            aaa.is_locked = this.lockedActions.includes(aaa.code)
            return aaa
          })
        }
        aa.is_locked = aa.actions
          ? aa.actions.every(aaa => aaa.is_locked)
          : this.lockedActions.includes(aa.code)
        return aa
      })
      // console.log(res)
      this.l_solution = res
    },
    assignLockedActions() {
      this.setSolution(this.solution)
    },
  },
  computed: {
    canLock() {
      // works together with reseting grouping in watcher on rangeBuilderV2
      return this.l_solution.length > 2
    },
  },
  watch: {
    solution: {
      handler: 'setSolution',
      immediate: true,
    },
    lockedActions: {
      handler: 'assignLockedActions',
      immediate: false,
    },
  },
  components: {
    NumberInput,
    RangeInput,
    GwBtns,
  },
}
</script>
<style lang="scss" scoped>
.rrbldfreq {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  flex: 1;
  cursor: default;
  background: var(--clr-black-1);
  padding: 0.5rem;
  border-radius: 4px;
  &_actions {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.66rem;
    min-height: 0;
    min-width: 0;
    flex: 1;
    padding: 0.5rem;
    &_item {
      display: flex;
      align-items: center;
      &_name {
        white-space: nowrap;
        font-weight: 500;
        width: 7.25rem;
      }
      &_slider {
      }
      &_input {
      }
    }
  }
}
</style>
